import { subselect } from './root';
import { propertiesSelector } from './properties';
import { PLAYER_STATE_STATUSES } from '../constants';

const isLoadingSelector = (playerState) => {
  const { status } = propertiesSelector(playerState);

  return status === PLAYER_STATE_STATUSES.LOADING;
};

export const playerIsLoadingSelector = subselect(isLoadingSelector);
